import { getEmployeesForTable } from "@api/employeesForTable";
import { EmployeeType } from "@type/HRM/employees";
import { PaginationType } from "@type/HRM/pagination";
import { useEffect, useState } from "react";

export const useEmployeesForTable = () => {
  const [employees, setEmployees] = useState([] as EmployeeType[]);
  const [pagination, setPagination] = useState({} as PaginationType);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const handleQuery = (key: string, value: number | boolean | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));
  useEffect(() => {
    setLoading(true);
    getEmployeesForTable(query)
      .then((res) => {
        setEmployees(res.data.data);
        setPagination({
          total: res.data.total,
          size: res.data.size,
          page: res.data.page,
        });
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [query]);

  return {
    employees,
    error,
    loading,
    handleQuery,
    pagination,
  };
};
